import { CDW_EDUCATION_PRIVACY_URL } from '@cdw-ae/common-data';

/**
 * Shared URLs used across all environments.
 * These URLs remain constant regardless of deployment environment.
 */
export const sharedUrls = {
  support: {
    helpCenter: 'https://amplifiedlabs.zendesk.com/hc/en-us',
  },
  legal: {
    /**
     * The console's copies of the customer app's legal links follow whatever
     * product decides there (EDUS-2849): one label, "Privacy Policy", pointing
     * here. The Amplified IT "Terms of Service" link was removed alongside the
     * customer sign-in page's.
     */
    privacyNotice: CDW_EDUCATION_PRIVACY_URL,
  },
};
